import { config } from "src/lib/config";

export const trimUrl = (url: string) => {
  return url.split("?")[0].split(config.gisApiUrl)[1];
};

export const getGISUrl = (url: string) => {
  return `${config.gisApiUrl}${trimUrl(url)}`;
};
